module.exports = __webpack_public_path__ + "img/b2.b53ee414.jpg";